module.exports = __webpack_public_path__ + "img/wechat.7b76fc3b.png";